module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_m_albino.ff0aa79e.png";